import { Loading3QuartersOutlined } from '@ant-design/icons';
import { t } from '@framework/i18n';
import type { SpinProps } from 'antd/es/spin/index';
import * as React from 'react';

export const tableLoaderSpin = (loading?: boolean) => {
  if (!loading) {
    return undefined;
  }
  const spin: SpinProps = {
    size: 'large',
    indicator: (
      <Loading3QuartersOutlined
        spin
        aria-label={t('loader.loader-spin.icon-aria', 'Caricamento...')}
      />
    ),
    spinning: loading,
  };
  return spin;
};
